import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

export const EN_SERVICE_LINKS = [
  { label: 'Physiotherapy in Belgrade', href: '/physical-therapy-belgrade' },
  { label: 'English-speaking physiotherapist', href: '/english-speaking-physiotherapist-belgrade' },
  { label: 'Chiropractic and manual therapy', href: '/chiropractor-belgrade' },
  { label: 'Sports injury rehabilitation', href: '/sports-injury-rehabilitation-belgrade' },
  { label: 'ACL rehabilitation', href: '/acl-knee-rehabilitation-belgrade' },
  { label: 'Shockwave therapy', href: '/heel-spur-shockwave-therapy-belgrade' },
  { label: 'Price list in English', href: '/prices' },
];

/** Compact footer column with links to the English landing pages (all languages). */
export const EnglishFooterLinks = () => (
  <div>
    <h3 className="text-lg font-semibold mb-4">English-speaking patients</h3>
    <ul className="space-y-2 text-sm text-muted-foreground">
      {EN_SERVICE_LINKS.map((l) => (
        <li key={l.href}>
          <Link to={l.href} className="hover:text-foreground transition-colors">
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

/**
 * In-page cross-link block shown only when the UI language is English
 * (homepage, services, price list) — keeps Serbian pages untouched.
 */
const EnglishServicesLinks = () => {
  const { i18n } = useTranslation();
  if (i18n.language !== 'en') return null;
  return (
    <section aria-labelledby="en-services-h" className="container mx-auto max-w-6xl px-4 py-10">
      <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
        <h2 id="en-services-h" className="text-2xl font-bold text-foreground">Physiotherapy in Belgrade — in English</h2>
        <p className="mt-2 text-muted-foreground">
          Dedicated English pages for expats and visitors: assessment, treatment and booking in English, Block 64, New Belgrade.
        </p>
        <ul className="mt-5 flex flex-wrap gap-2.5">
          {EN_SERVICE_LINKS.map((l) => (
            <li key={l.href}>
              <Link
                to={l.href}
                className="inline-flex items-center gap-1.5 rounded-full border border-border px-4 py-2 text-sm font-medium hover:border-primary hover:text-primary"
              >
                {l.label} <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default EnglishServicesLinks;
